import { getCookie, removeCookie } from './Cookies';
import { toast } from 'react-toastify';

export const getUserLoginToken = () => {
    // always fetch the latest value from the cookie:
    const userData = getUser();
    const token = userData?.token;
    return token;
};

export const CookieNames = Object.freeze({
    userInfo: 'user-info',
    persistenceKey: 'persistence-key',
    userId: 'userId',
    userName: 'userName',
    firstName: 'firstName',
    lastName: 'lastName',
    emailAddress: 'emailAddress',
    customerId: 'customerId',
    userRole: 'userRole',
    isAdmin: 'isAdmin',
    adminTier: 'adminTier',
});

/** Get User info object from cookies
 * @returns {object} - User object
 */
export const getUser = () => getCookie('user-info');
export const getToken = () => getCookie('persistence-key');
export const getUserId = () => getCookie('userId');
export const getLoginName = () => getCookie('userName');
export const getUserName = () => getCookie('userName');
export const getFirstName = () => getCookie('firstName');
export const getLastName = () => getCookie('lastName');
export const getUserEmailAddress = () => getCookie('emailAddress');
export const getCustomerId = () => getCookie('customerId');
export const getUserRole = () => getCookie('userRole');
/** True if the isAdmin cookie is set. universal-cookie auto-JSON-parses cookie values, so a
 * cookie stored as the string "true" comes back as the boolean `true`, not the string --
 * normalize here so callers don't have to know that. */
export const getIsAdminStatus = () => {
    const v = getCookie('isAdmin');
    return v === true || v === 'true';
};
/** Three-tier Advanced Admin permission for the logged-in user, set at login (see
 * getAdminTier in athos-node-api's HelperFunctions.js). Used to gate UI -- the AA nav menu
 * and the Create User button -- client-side; the real enforcement is server-side
 * (requireAdminTier/requireSuperAdminTier), this just avoids showing controls that would 403.
 * @returns {'SuperAdmin'|'Admin'|'Accounting'|null}
 */
export const getAdminTier = () => {
    const v = getCookie('adminTier');
    return v === 'SuperAdmin' || v === 'Admin' || v === 'Accounting' ? v : null;
};

export const getUserInformation = () => {
    // return user;
    return getUser();
};

export const removeAllCookies = () => {
    removeCookie('user-info');
    removeCookie('persistence-key');
    removeCookie('userId');
    removeCookie('customerId');
    removeCookie('userName');
    removeCookie('firstName');
    removeCookie('lastName');
    removeCookie('emailAddress');
    removeCookie('userRole');
    removeCookie('isAdmin');
    removeCookie('adminTier');
};

/** Comprehensive logout function that handles admin logout with page reload
 * @param {boolean} isAdmin - Whether the user is an admin
 * @param {Function} showMessage - Function to show logout message
 * @param {Function} navigate - Navigation function
 */
export const logoutUser = (isAdmin = false, showMessage = null, navigate = null) => {
    // Dismiss all loading toasts (including "Logging in..." if present)
    toast.dismiss();
    
    // Remove all authentication cookies
    removeAllCookies();
    
    // Show logout message if provided
    if(showMessage){
        showMessage('Logged out', 'bottom-center', 2500);
    }
    
    // Handle admin logout with page reload
    if(isAdmin){
        console.log('Admin user logged out, reloading page...');
        setTimeout(() => {
            window.location.reload();
        }, 1000); // Small delay to show logout message
    }else if(navigate){
        // For non-admin users, navigate to home
        navigate('/');
    }
};

const hasValue = (v) => v != null && String(v).trim() !== '';

/** True when a non-empty session token exists in a client-readable cookie. Prefer `useAuth()` for UI gating.
 * Accepts either the `persistence-key` cookie or the token inside the `user-info` cookie: the latter is
 * what the API Bearer header is built from (see nodeAuthHeader), and the two cookies are written and
 * expire independently (e.g. LoginModal re-writes persistence-key), so checking only one can report
 * "logged out" for a customer whose API calls are still authenticated. */
export const isUserLoggedIn = () => hasValue(getCookie('persistence-key')) || hasValue(getUserLoginToken());
